import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

/**
 * here we're removing winning symbols
 */
export class AvalancheRemoveWinsState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {

	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(AvalancheReelsEvents.REMOVING_WIN_FINISHED, this.onRemovingFinished);
		this.on(WinPresentationEvents.COUNTUP_FINISHED, this.onInitialWinCountupFinished);
		this.on(FlowModuleEvents.NO_WIN, this.onNoWin);
	}

	protected onInitialWinCountupFinished(): void {
		this.startSymbolsRemoving();

		this.emit(AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED);
	}

	protected onNoWin(): void {
		this.onInitialWinCountupFinished();
	}

	protected startSymbolsRemoving(): void {
		throw new Error('AvalancheRemoveWinsState::startSymbolsRemoving must be overridden');
	}

	protected onRemovingFinished(): void {
		this.module.gotoState(AvalancheReelsModule.ADD_SYMBOLS_STATE);
	}

	protected finishRemoving(): void {
		this.module.gotoState(AvalancheReelsModule.ADD_SYMBOLS_STATE);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheRemoveWinsState.ts